import { convertHelpers } from "../../common/convert";
import { getUserCollectionData, updateUserCollectionData } from "../../firestoreData/appUserData/getAppUserData";

export const appUserDataReducerTypes = {
  checkConversation: 'checkConversation',
  handleError: 'handleError',
  handleGet_conversations: 'handleGet_conversations',
  handleGetNotes: 'handleGetNotes',
  handleLoadConversations: 'handleLoadConversations',
  handleLoadNotes: 'handleLoadNotes',
  handleMessageSuccess: 'handleMessageSuccess',
  loadConversation: 'loadConversation',
  handleSaveNote: 'handleSaveNote',
  setMessageData: 'setMessageData',
}

export const userCollectionTypes = {
  conversations: 'conversations',
  notes: 'notes',
}
export const _conversationsCollection = '_conversations'
export const _notesCollection = '_notes'

export const appUserDataReducer = (state, action) => {

  const { appUserAccess, messageData, paps_state } = state
  const { allowConversations, allowNotes } = state
  const { data, type, dispatch, resultData, noteId } = action

  const { handleLoadConversations, handleLoadNotes, handleError } = appUserDataHandlers(dispatch)

  switch (type) {

    case appUserDataReducerTypes.handleGet_conversations:
      if (allowConversations) {
        getUserCollectionData(appUserAccess, userCollectionTypes.conversations, action.paps_state, handleLoadConversations, handleError)
      } else {
        return { ...state, conversations: {} }
      }
      return { ...state }

    case appUserDataReducerTypes.handleGetNotes:
      if (allowNotes) {
        getUserCollectionData(appUserAccess, userCollectionTypes.notes, action.paps_state, handleLoadNotes, handleError)
      } else {
        return { ...state, notes: {} }
      }
      return { ...state }


    case appUserDataReducerTypes.handleSaveNote:
      updateUserCollectionData(appUserAccess, userCollectionTypes.notes, paps_state, action.note, action.callback)
      return { ...state }

    case appUserDataReducerTypes.handleLoadConversations:
      return {
        ...state,
        conversations: resultData,
      }

    case appUserDataReducerTypes.handleLoadNotes:
      convertHelpers.createItemKeys(resultData)
      return { ...state, notes: resultData }

    case appUserDataReducerTypes.handleError:
      return {
        ...state,
        err: action.err,
      }

    case appUserDataReducerTypes.setMessageData:
      const md = { ...messageData }
      md[data.placeholder] = data.value
      return {
        ...state,
        messageData: md,
        messageReady: md && md.title && md.body ? true : false
      }

    default:
      return { ...state }
  }
}

export const appUserDataInitialState = (appUser, paps_state, page_state, page_fns, aps_appUserSettings) => {
  return {
    appUser,
    paps_state,
    messageData: {},
    messageReady: false,
    fromConversation: null,
    sentConversation: null,
    page_state,
    page_fns,
    aps_appUserSettings,
  }
};

export const appUserDataHandlers = (dispatch) => {
  return {
    checkConversation: () => { dispatch({ type: appUserDataReducerTypes.checkConversation }) },
    handleError: (err) => { dispatch({ type: appUserDataReducerTypes.handleError, err }) },
    handleGet_conversations: (paps_state) => { dispatch({ type: appUserDataReducerTypes.handleGet_conversations, dispatch, paps_state }) },
    handleGetNotes: (paps_state) => { dispatch({ type: appUserDataReducerTypes.handleGetNotes, dispatch, paps_state }) },
    handleLoadConversations: (resultData) => { dispatch({ type: appUserDataReducerTypes.handleLoadConversations, resultData }) },
    handleLoadNotes: (resultData) => { dispatch({ type: appUserDataReducerTypes.handleLoadNotes, resultData }) },
    handleSaveNote: (note, callback) => { dispatch({ type: appUserDataReducerTypes.handleSaveNote, dispatch, note, callback }) },
    setMessageData: (data) => { dispatch({ type: appUserDataReducerTypes.setMessageData, data }) },
  }
} 